module.exports = __webpack_public_path__ + "images/psp/SizeGuide/updated/small-self-5x10-50x400.svg";